export default function HeroSection() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden pt-[72px]"
    >
      {/* Decorative background blobs */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/60 blur-3xl -translate-y-1/3 translate-x-1/4 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-accent-100/40 blur-3xl translate-y-1/3 -translate-x-1/4 pointer-events-none" />

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12 py-10 md:py-14">
          {/* Left content */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Pre-title tag */}
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse" />
              全网吃瓜资源 · 每日持续更新
            </div>

            {/* H1 */}
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-3">
              51吃瓜视频
              <span className="block text-foreground-700 font-sans text-xl md:text-2xl lg:text-3xl font-light mt-1">
                全网最新吃瓜爆料视频平台
              </span>
            </h1>

            {/* Slogan */}
            <p className="text-primary-600 font-medium text-sm md:text-base mb-5">
              一手热门爆料，精彩视频不间断
            </p>

            {/* Intro paragraph */}
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              51吃瓜视频网是全网领先的吃瓜爆料视频聚合平台，每日追踪娱乐圈热点、明星八卦、社会事件等最新动态。通过51吃瓜官网全网最新入口，直达海量热门视频资源，一手爆料新鲜速递，让您不错过任何精彩内容。本站为51吃瓜网站首页官方地址，支持PC端与移动端流畅访问，并持续优化浏览体验与内容覆盖广度。
            </p>

            {/* Stats row */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className="ri-flashlight-line text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">覆盖热点</div>
                  <div className="text-sm font-semibold text-foreground-800">每日更新50+条</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-user-heart-line text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">用户信赖</div>
                  <div className="text-sm font-semibold text-foreground-800">千万级吃瓜平台</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                  <i className="ri-shield-check-line text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">安全保障</div>
                  <div className="text-sm font-semibold text-foreground-800">稳定极速访问</div>
                </div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); handleNav('#index'); }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line text-base"></i>
                立即浏览热门专题
              </a>
              <a
                href="#app"
                onClick={(e) => { e.preventDefault(); handleNav('#app'); }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium text-sm rounded-lg transition-colors cursor-pointer whitespace-nowrap border border-background-200"
              >
                <i className="ri-download-2-line text-base"></i>
                下载51吃瓜APP
              </a>
            </div>
          </div>

          {/* Right visual */}
          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative">
              <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=An%20artistic%20abstract%20digital%20composition%20representing%20trending%20viral%20entertainment%20content%20and%20media%20buzz%20warm%20coral%20amber%20and%20terracotta%20color%20palette%20with%20floating%20video%20play%20icons%20notification%20badges%20and%20trending%20graphs%20modern%20editorial%20design%20with%20soft%20gradients%20and%20glowing%20accent%20elements%20against%20dark%20warm%20background%20sophisticated%20digital%20art&width=700&height=525&seq=hero-main-visual&orientation=landscape"
                  alt="51吃瓜视频 - 全网最新吃瓜爆料视频平台主视觉"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Floating badge cards */}
              <div className="absolute -bottom-3 -left-3 bg-background-50 rounded-xl px-4 py-3 shadow-sm border border-background-200/70">
                <div className="flex items-center gap-2">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs">
                    <i className="ri-play-fill"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">今日更新</div>
                    <div className="text-sm font-semibold text-foreground-800">56条爆料视频</div>
                  </div>
                </div>
              </div>
              <div className="absolute -top-3 -right-3 bg-background-50 rounded-xl px-4 py-3 shadow-sm border border-background-200/70">
                <div className="flex items-center gap-2">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xs">
                    <i className="ri-line-chart-line"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">实时热度</div>
                    <div className="text-sm font-semibold text-foreground-800">9.8万人在线</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}